import React, { FunctionComponent } from 'react';
import { Condition } from '@upstart/harmony/lib/constants';
import { DealerLaunchStepProps } from '../types';
import styles from '../styles.module.scss';
import { Radio } from '../../Input/Radio/Radio';
import { DealerLaunchFormCardLayout } from '../DealerLaunchFormCardLayout';
import { useLaunchpadForm } from '../../../hooks/useLaunchpadForm';
import { Dealer } from '../../../types/dealerTypes';
import { addDeskingDefaults } from '../defaults';

const typeMapping = {
  label: {
    [Condition.NEW]:
      'Should we apply a trade-in tax credit for new vehicles by default?',
    [Condition.USED]:
      'Should we apply a trade-in tax credit for used vehicles by default?',
    [Condition.CPO]:
      'Should we apply a trade-in tax credit for CPO vehicles by default?',
  },
};

export const DealerLaunchTradeInTaxCredit: FunctionComponent<DealerLaunchStepProps<{
  type: Condition;
}>> = ({
  dealer,
  prevStep,
  nextStep,
  step: {
    stepProps: { type },
  },
}) => {
  const form = useLaunchpadForm<Dealer>({
    defaultValues: addDeskingDefaults(dealer),
  });

  return (
    <DealerLaunchFormCardLayout
      className={styles.widgetsStep}
      form={form}
      title="Tell Us About How Your Payments Are Configured"
      subTitle=""
      cardTitle={typeMapping.label[type]}
      prevStep={prevStep}
      onFormSubmit={nextStep}
    >
      <Radio
        className="flex-column"
        name={`desking.useTradeInAllowanceForTax.${type}` as never}
        options={[
          {
            label: 'Yes',
            value: true,
          },
          {
            label: 'No',
            value: false,
          },
        ]}
        form={form}
      />
    </DealerLaunchFormCardLayout>
  );
};
